import React, {
    useContext,
} from 'react';

import { LocaleContext } from 'app/containers/LocaleProvider';
import { sortDishesByPriorityAndVisibility } from 'app/utils/dish';
import { Mobile } from 'app/components/Responsive';

import Dish from '../../Dish';
import { DishCategoryTextLine } from '../DishCategoryTextLine';
import { DishCategorySecondaryLinkToMenu } from './DishCategorySecondaryLinkToMenu';

import styles from './dish-category-secondary.scss';


export function DishCategorySecondary(props) {
    const {
        colors,
        title: titleRu,
        titleEn,
        dishes,
        basketDishes,
        buttonsDisabled,
        canChangePortionsCount,
        promoCheckoutDishObserver,
    } = props;

    const { locale } = useContext(LocaleContext);

    const titles = {
        ru: titleRu,
        en: titleEn,
    };
    const title = titles[locale];

    const sortedDishes = sortDishesByPriorityAndVisibility(dishes);

    const priorityDishes = sortedDishes.filter((d) => d.layout !== 'upsell');
    const upsellDishes = sortedDishes.filter((d) => d.layout === 'upsell');

    return (
        <div className={styles['secondary-category__container']}>
            <div>
                <p className={styles['secondary-category__title']}>
                    <DishCategoryTextLine>
                        {title}
                    </DishCategoryTextLine>
                </p>
            </div>
            <div className={styles['secondary-category__dishes']}>
                {priorityDishes.map((dish, index) => {
                    const basketDish = basketDishes.find((bd) => {
                        if (dish.isSet) {
                            return dish.dishes.includes(bd.id);
                        }
                        return bd.id === dish.id;
                    }) || { portion: 0 };

                    const isOddDishNumber = (dishes.length % 2) === 1;
                    const isLastDish = index === (dishes.length - 1);
                    const isCentered = isOddDishNumber && isLastDish;

                    return (
                        <Dish
                            // layout="secondary"
                            index={index}
                            {...dish}
                            portion={basketDish.portion}
                            buttonsDisabled={buttonsDisabled}
                            isFirstCategory={false}
                            isCentered={isCentered}
                            key={dish.id}
                            canChangePortionsCount={canChangePortionsCount}
                            areDetailsEnabled={false}
                            colors={colors}
                            promoCheckoutDishObserver={promoCheckoutDishObserver}
                            isNutritionEnabled={false}
                        />
                    );
                })}

                <Mobile>
                    <div className={styles['secondary-category__upsell-title']}>
                        <p className={`${styles['secondary-category__title']} ${styles['secondary-category__title--align-left']}`}>
                            Другие супер-блюда
                        </p>
                    </div>
                </Mobile>
                <div className={styles['secondary-category__upsell-container']}>
                    {upsellDishes.map((dish, index) => {
                        const basketDish = basketDishes.find((bd) => {
                            if (dish.isSet) {
                                return dish.dishes.includes(bd.id);
                            }
                            return bd.id === dish.id;
                        }) || { portion: 0 };

                        return (
                            <Dish
                                index={index}
                                {...dish}
                                portion={basketDish.portion}
                                buttonsDisabled={buttonsDisabled}
                                isFirstCategory={false}
                                isCentered={false}
                                key={dish.id}
                                canChangePortionsCount={canChangePortionsCount}
                                areDetailsEnabled={false}
                                colors={colors}
                                promoCheckoutDishObserver={promoCheckoutDishObserver}
                                isNutritionEnabled={false}
                            />
                        );
                    })}
                    <DishCategorySecondaryLinkToMenu />
                </div>
            </div>
        </div>
    );
}
